import React, { useEffect, useState } from 'react'

// this hoc wraps provides a mounted property with a value of true once the component is mounted.
// this is useful for re-rendering after mount in order to kick off an animation
const withMounted = WrappedComponent => props => {
  const [mounted, setMount] = useState(false)

  useEffect(() => {
    if (!mounted) {
      requestAnimationFrame(() => {
        setMount(true)
      })
    }
  }, [mounted])

  return <WrappedComponent {...props} mounted={mounted} />
}

export default withMounted
